import * as THREE from 'three'
// Rounded rectangle
// Example: https://github.com/mrdoob/three.js/blob/master/examples/webgl_geometry_shapes.html
export default function RoundedRectangle(x = 0, y = 0, width, height, edgeRadius) {
    var shape = new THREE.Shape()
    ;(function roundedRect(ctx, x, y, width, height, radius) {
        ctx.moveTo(x, y + radius)
        ctx.lineTo(x, y + height - radius)
        ctx.quadraticCurveTo(x, y + height, x + radius, y + height)
        ctx.lineTo(x + width - radius, y + height)
        ctx.quadraticCurveTo(x + width, y + height, x + width, y + height - radius)
        ctx.lineTo(x + width, y + radius)
        ctx.quadraticCurveTo(x + width, y, x + width - radius, y)
        ctx.lineTo(x + radius, y)
        ctx.quadraticCurveTo(x, y, x, y + radius)
    })(shape, x, y, width, height, edgeRadius)

    shape.autoClose = true

    return new THREE.ShapeBufferGeometry(shape)
}
